import { useMemo } from 'react';

import { useFeatureFlags } from 'Utilities/hooks';

import { ContentType } from '../utilities/WordpressConstants';

import { WordpressState } from './useWPData';

type UseContentProps = Pick<WordpressState, 'data' | 'empty' | 'isGuideAuthors' | 'isBlog' | 'isPage'>;

export const useContentType = ({ data, empty, isBlog, isGuideAuthors, isPage }: UseContentProps) => {
  const { showWordpressGuideAuthorsPage } = useFeatureFlags();

  const contentType = useMemo((): ContentType => {
    if (isPage && !data?.content) {
      return ContentType.ERROR;
    }
    if (isGuideAuthors) {
      if (showWordpressGuideAuthorsPage) {
        return ContentType.AUTHOR;
      }

      return ContentType.ERROR;
    }
    if (isPage) {
      return ContentType.PAGE;
    }
    if (isBlog && empty) {
      return ContentType.EMPTY;
    }
    if (isBlog) {
      return ContentType.BLOG;
    }
    return ContentType.ERROR;
  }, [isPage, data?.content, isBlog, empty, isGuideAuthors]);

  return { contentType };
};
